// *******************************************************
// Scoring.js
// -------------------------------------------------------
// Contains contants for scoring through the app
// -------------------------------------------
export const LOW = "LOW";
export const MEDIUM = "MEDIUM";
export const HIGH = "HIGH";
// -------------------------------------------



// WEBPACK FOOTER //
// ./src/constants/scoring.js